<div class="registration-layout">
    <div class="container-registration registration__wrapper">
        <div class="registration-aside-panel aside-panel-step-{{currentStep}}">
            <a class="synced-logo">
                <img src="../../../assets/img/logo-black.svg" alt="">
            </a>
        </div>
        <router-outlet></router-outlet>
    </div>
</div>